/**
 * @format
 */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { submitNewsListAPI, NewsItem } from '../api/adserver';
import { RootState } from './rootReducer';
import { AppThunk } from './store';

interface NewsState {
  loading: boolean;
  isSucess: boolean;
  errMsg: string | null;
  data: Array<NewsItem>;
}

const initialState: NewsState = {
  loading: false,
  isSucess: false,
  errMsg: null,
  data: [],
};

const newsSlice = createSlice({
  name: 'News',
  initialState,
  reducers: {
    fetchNewsListProcessing(state) {
      return { ...state, loading: true };
    },
    fetchNewsListSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        isSucess: true,
      };
    },
    fetchNewsListFailed(state, action: PayloadAction<string>) {
      return { ...state, loading: false, errMsg: action.payload };
    },
  },
});

export const {
  fetchNewsListProcessing,
  fetchNewsListSuccess,
  fetchNewsListFailed,
} = newsSlice.actions;

export const selectNews = createSelector(
  (state: RootState) => state.news,
  (NewsState: NewsState) => {
    return {
      ...NewsState,
    };
  },
);

export const getNewsList = (): AppThunk => async (dispatch) => {
  try {
    dispatch(fetchNewsListProcessing());
    const data = await submitNewsListAPI();
    dispatch(fetchNewsListSuccess(data));
  } catch (err: unknown) {
    let message = 'unknown error';
    if (err instanceof Error) {
      message = err.toString();
    }
    dispatch(fetchNewsListFailed(message));
  }
};

export default newsSlice.reducer;
